<template>
  <div class="switch-field" :class="theme">
    <span class="slider" :class="`slide-${currentValue}`"></span>
    <label class="switch-state switch-on">
      <input type="radio" :name="name" :value="0" v-model="currentValue" />
      <span class="text" :class="{active: currentValue === 0}">{{ offLabel }}</span>
    </label><label class="switch-state switch-off">
      <input type="radio" :name="name" :value="1" v-model="currentValue" />
      <span class="text" :class="{active: currentValue === 1}">{{ onLabel }}</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true }, // the name attribute of the radio elements
    value: { type: Number, default: 0 }, // defaults to "off"
    onLabel: { type: String, default: "Yes" },
    onTheme: { type: String, default: "success" },
    offLabel: { type: String, default: "No" },
    offTheme: { type: String, default: "info" }
  },
  data() {
    return {
      currentValue: 0
    };
  },
  computed: {
    theme() {
      return !this.currentValue ? this.offTheme : this.onTheme;
    }
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
    currentValue(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.currentValue = this.value;
  }
};
</script>
